import React, { Component } from "react";
import Input from "../Input/Input";
import Button from "../button/button";
import {
	getAllSales,
	handleSearch,
	openOrCloseSearchDesktop,
	searchIsLoading
} from "../../js/actions/sales";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Loading from "../Loading/Loading";

class SearchWeb extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchIsFetching: false
		};
	}

	expandOrCollapse = action => {
		let element = document.getElementById("search");
		if (action) {
			this.props.openOrCloseSearchDesktop(true);
			setTimeout(() => {
				document.getElementById("search").focus();
			}, 100);
		} else {
			this.props.openOrCloseSearchDesktop(false);
		}
	};
	handleChange = event => {
		if (event.inTimeOut) {
			this.props.searchIsLoading(event.value);
			return;
		}

		if (event.length === 0) {
			this.props.getAllSales(this.props.filteredStatements);
			return;
		}

		this.props.handleSearch(event);
	};
	resetSearch = event => {
		if (this.props.searched.length > 0) {
			this.props.getAllSales(this.props.filteredStatements);
		}

		this.expandOrCollapse(false);
	};
	searchInputBlur = event => {
		this.expandOrCollapse(false);
	};

	componentDidMount() {
		console.log('searchWeb');

		if (this.props.searchIsOpen) {
			this.expandOrCollapse(true);
		}

		if (window.location.search.includes('?searchTerm')) {
			const [, term] = window.location.search.split('=');

			this.props.handleSearch(term);
		}
	}

	componentWillReceiveProps(prev, next) { }

	render() {
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "search-web-offers";
		return (
			<div className="search-web" data-action={dataAction}>
				{!this.props.searchIsOpen && (
					<Button
						id="search-button"
						className="btn-gray-md-icon search-web-button--magnify"
						onClick={e => this.expandOrCollapse(true)}
					>
						<i className="icon-search" />
					</Button>
				)}

				{this.props.searchIsOpen && (
					<Button
						id="search-button"
						className="btn-gray-md-icon search-web-button--close"
						onMouseDown={e => this.resetSearch(e)}
					>
						{!this.props.searchIsFetching && <i className="icon-close" />}
						{this.props.searchIsFetching && <Loading width={25} height={25} />}
					</Button>
				)}

				{this.props.searchIsOpen && (
					<Input
						onChange={e => this.handleChange(e)}
						id="search"
						placeholder="Localizador ou transação"
						className="search-field"
						debounce={1000}
						value={this.props.searched}
						onBlur={e => this.searchInputBlur(e)}
						type="search"
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	searchIsOpen: state.mySales.searchIsOpen,
	searchIsFetching: state.mySales.searchIsFetching,
	searched: state.mySales.searched,
	filteredStatements: state.mySales.filteredStatements
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleSearch,
			openOrCloseSearchDesktop,
			getAllSales,
			searchIsLoading
		},
		dispatch
	);
export default connect(mapStateToProps, mapDispatchToProps)(SearchWeb);
